import { updateMicroStepEvent } from '@cof/refi-web-sdk/dist/utils/update-progress-bar';
import { ApplicationService } from '../../services/application.service.js';

export const stateChangedEvent = (
  element,
  currentSteps,
  currentStepIndex,
  forceUrlUpdate = false
) => {
  if (!ApplicationService.isUpfrontOffers) {
    updateMicroStepEvent(
      currentStepIndex === 0 ? '' : currentSteps[currentStepIndex - 1]
    );
  } else if (currentStepIndex !== 0) {
    updateMicroStepEvent(currentSteps[currentStepIndex - 1]);
  }

  if (ApplicationService.isV2Routing) {
    element.dispatchEvent(
      new CustomEvent('next-step', {
        bubbles: true,
        composed: true,
        detail: {
          step: currentSteps[currentStepIndex],
          redirect: forceUrlUpdate,
        },
      })
    );
  } else {
    element.dispatchEvent(
      new CustomEvent('host-app-event', {
        bubbles: true,
        composed: true,
        detail: {
          actionName: 'state-changed',
          data: { state: currentSteps[currentStepIndex] },
          forceUrlUpdate,
        },
      })
    );
  }
};

export const showBackButtonEvent = (element, showBackButton = false) => {
  element.dispatchEvent(
    new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'show-back-button',
        showBackButton,
      },
    })
  );
};

export const hideLoaderSpinnerEvent = (element) => {
  element.dispatchEvent(
    new CustomEvent('hide-loader-spinner', {
      bubbles: true,
      composed: true,
    })
  );
};
